import React from 'react';
import './sessionItemCard.module.scss';
import { RadioCard } from '../../atoms/select/RadioCard';
import moment from 'moment';
import { SessionIndexView } from '../../../types/sessions';

type Props = {
  session: SessionIndexView;
  selected: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect: () => any;
};

export const SessionItemCard = ({ session, selected, onSelect }: Props) => {
  const startsAt = moment(session.starts_at);
  const endsAt = moment(session.ends_at);
  const WEEKDAY_LABELS = ['月', '火', '水', '木', '金', '土', '日'];
  const weekday = startsAt.isoWeekday();
  const weekdayText = WEEKDAY_LABELS[weekday - 1];
  return (
    <RadioCard
      checked={selected}
      styleName="session-item-card"
      className="session-item-card"
      data-value={String(session.id)}
      label={
        <div styleName="body">
          <div styleName="date">
            {startsAt.format('MM月DD日')}/{weekdayText}
          </div>
          <div styleName="time-and-location">
            {startsAt.format('HH:mm')}-{endsAt.format('HH:mm')}/オンライン
          </div>
        </div>
      }
      onCheck={onSelect}
    />
  );
};
